export const dispatchType = {
  onboarding: 'get-onboarding-tutors',
  zero_session: 'get-zero-session-tutors',
  intern: 'get-intern-tutors',
  cro_wise: 'get-cro-wise-tutors',
  tutor_pool: 'get-tutor-pool',
  resigned: 'get-resigned-tutors',
  slot_utlized: 'get-tutor-slots-utilized',
  subject_wise: 'get-subject-wise-trainer-free-slots-trainer-list',
};
